import type { BranchAccess } from '../../../shell/session/store/sessionTypes';
import { SESSION_CACHE_MS } from '../../../shell/session/sessionCacheTtl';

let branchesCache: { value: BranchAccess[]; fetchedAt: number } | null = null;

export function setUserBranchesCache(list: BranchAccess[]): void {
  branchesCache = { value: list, fetchedAt: Date.now() };
}

export const primeUserBranchesCache = setUserBranchesCache;

export function getUserBranchesCacheIfFresh(now = Date.now()): BranchAccess[] | null {
  if (!branchesCache || now - branchesCache.fetchedAt >= SESSION_CACHE_MS) {
    return null;
  }
  return branchesCache.value;
}

export function clearUserBranchesCache(): void {
  branchesCache = null;
}
